import { render, staticRenderFns } from "./LookupCode.vue?vue&type=template&id=22fe1c36&scoped=true"
import script from "./LookupCode.vue?vue&type=script&lang=js"
export * from "./LookupCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe1c36",
  null
  
)

export default component.exports